export async function fetchData(url) {
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export function convertToSlug(text) {
  if (!text) return ""; // Check if text is undefined or null
  return text
    .toLowerCase()
    .replace(/ /g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove non-word characters
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+|-+$/g, ""); // Remove leading and trailing -
}

export function nl2br(str) {
  return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
}
